
import { useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';
import Loader from '../Layout/Loader';
import {  exportToExcel, setFocus, setTitle, Amount,  formatDate, BindReportGrid } from '../Common/Common';
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";

const VatTaxSetting = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [MenuText, setMenuText] = useState("Tax Setting");

    const [tableData, setTableData] = useState({ })
    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })
    const [FormData, setFormData] = useState({
        VatTaxID: "0",
        ApplicableFrom: new Date(),
        TaxType:"",
        TaxPer: "0.00"
    });

    const handleClear = async () => {
        setFormData({
            VatTaxID: "0",
            ApplicableFrom: new Date(),
            TaxType:"",
            TaxPer: "0.00"
        });

        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        getVatTaxData()
    }
    useEffect(() => {
        setTitle('VatTaxSetting', setOpen);
        setFocus('ddlTaxType')
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);
    useEffect(() => {
        getVatTaxData();
       
    }, [filterData.PageIndex]);
    console.log(filterData, "filterdata")

    const handleSubmit = async () => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode)
        let data = {
            ...FormData, Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/Setting/InsertUpdateVatTaxSetting`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);

                handleClear();
                getVatTaxData();
                setIsLoading(false);
            }
            else if (res.status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.status === 'ERROR') {
                AlertBox(res.status, res.message, res.focus);


                setIsLoading(false);
            }
            if (res.focus !== "") {
                setFocus(res.focus)
            }

        })
    }
    const getVatTaxData =  (Type = 'S') => {
        const loginCodeString = String(LoginUserCode)
        const data = {
            ...filterData, Type: Type, Token, LoginUserCode: loginCodeString ,PageName:"VatTaxSetting"
        }
        console.log(filterData, "filterData")
        setIsLoading(true)
        post(`${API_SERVER}/api/Setting/ShowExVatTaxSetting`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
               
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'VatTaxSetting');
                    }
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            
            else if (res.Status === 'ERROR' && res.Message !== "") {
                AlertBox(res.status, res.message, res.focus);

                setTableData({})
            }
            setIsLoading(false)
        })
    }
    const handleEditData =  (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        const vattaxId = ID.Edit
        let data = {
            Token, LoginUserCode: loginCodeString, VatTaxID: vattaxId
        }
        post(`${API_SERVER}/api/Setting/EditVatTaxSetting`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                setFormData({
                    VatTaxID: res.vatTaxID,
                    ApplicableFrom: res.applicableFrom,
                    TaxType:res.taxType,
                    TaxPer: res.taxPer,
                });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);

            }
            setIsLoading(false);
        })
    }
    const handleDeleteData = async (ID) => {
        const loginCodeString = String(LoginUserCode);
        setIsLoading(true)
        const vattaxId = ID.Del
        let data = {
            Token, LoginUserCode: loginCodeString, VatTaxID: vattaxId
        }
        post(`${API_SERVER}/api/Setting/DeleteVatTaxSetting`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                AlertBox(res.status, res.message, res.focus);
                getVatTaxData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);

                setIsLoading(false);
            }
        })
    }

    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
            FormName: "VatTaxMaster"
        })
        getVatTaxData();
    }
    const handleDownloadExcel = async () => {
        getVatTaxData('E');
    }

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Tax Type<span className="Required">*</span></label>
                                            <select
                                                className='form-control'
                                                disabled={FormData.VatTaxID !== "0" ? true : false}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtApplicableFrom')
                                                    };
                                                }}
                                                id="ddlTaxType"
                                                value={FormData.TaxType} onChange={(e) => setFormData({ ...FormData, TaxType: e.target.value })}>
                                                <option>-Select Tax Type-</option>
                                                <option value="COVIDLEVY">COVIDLEVY</option>
                                                <option value="GETFUND">GETFUND</option>
                                                <option value="NHIL">NHIL</option>
                                                <option value="VAT">VAT</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Applicable From<span className="Required">*</span></label>
                                            <DatePicker selected={FormData.ApplicableFrom}
                                                id='txtApplicableFrom'
                                                className="form-control"
                                                placeholderText='Applicable From'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => {
                                                    setFormData({ ...FormData, ApplicableFrom: formatDate(date) })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtTaxPer')
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                           
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Tax Per<span className="Required">*</span></label>
                                            <input
                                                id='txtTaxPer'
                                                type="text"
                                                maxLength="5"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSave')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Tax Percentage'
                                                value={FormData.TaxPer}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...FormData, TaxPer: Amount(e.target.value)
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button text-center">
                                            {FormData.VatTaxID !== '0' ? (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={filterData} searchHandle={searchHandle}  handleEditData={handleEditData} handleDeleteData={handleDeleteData} FormName='VatTaxMaster' />
            
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
         
        </main>
    )
}
export default VatTaxSetting    